export default __webpack_public_path__ + "static/media/bot_icon.b4ca975c.svg";